var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"field__content"},[_c('a-radio-group',{attrs:{"name":"radioGroup"},on:{"change":_vm.changeVal},model:{value:(_vm.val),callback:function ($$v) {_vm.val=$$v},expression:"val"}},[_c('a-radio',{attrs:{"value":'0'}},[_vm._v(" 否 ")]),_c('a-radio',{attrs:{"value":'1'}},[_vm._v(" 是 ")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }